import { apiFetch } from "./http";

// Çok-turlu, konu-kilitli AI Sohbet. Backend: go/internal/api/handler/ai_chat_sessions.go
export type ChatMessage = { role: "user" | "assistant"; content: string; created_at: string };
export type ChatSession = {
  id: string;
  title: string;
  messages?: ChatMessage[];
  created_at: string;
  updated_at: string;
};

export async function listChatSessions(): Promise<ChatSession[]> {
  const res = await apiFetch("/api/v1/ai/chat/sessions");
  if (!res.ok) throw new Error(`listChatSessions: HTTP ${res.status}`);
  const d = await res.json();
  return d.sessions ?? [];
}

export async function newChatSession(): Promise<ChatSession> {
  const res = await apiFetch("/api/v1/ai/chat/sessions", { method: "POST" });
  if (!res.ok) throw new Error(`newChatSession: HTTP ${res.status}`);
  return res.json();
}

export async function getChatSession(id: string): Promise<ChatSession> {
  const res = await apiFetch(`/api/v1/ai/chat/sessions/${id}`);
  if (!res.ok) throw new Error(`getChatSession: HTTP ${res.status}`);
  return res.json();
}

export async function deleteChatSession(id: string): Promise<void> {
  const res = await apiFetch(`/api/v1/ai/chat/sessions/${id}`, { method: "DELETE" });
  if (!res.ok && res.status !== 204) throw new Error(`deleteChatSession: HTTP ${res.status}`);
}

export type ChatReply = { reply: string; provider: string; model: string; session: ChatSession };
export async function sendChatMessage(id: string, message: string, answerLang?: string): Promise<ChatReply> {
  const res = await apiFetch(`/api/v1/ai/chat/sessions/${id}/messages`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ message, answer_lang: answerLang }),
  });
  if (!res.ok) { const txt = await res.text(); throw new Error(`HTTP ${res.status}: ${txt}`); }
  return res.json();
}
